const setWorksheetList = (data) => ({
  type: "SET_WORKSHEET_LIST",
  data,
});

export const mutation = {
  setWorksheetList,
};
